import AccountSection from './AccountSection';
export default AccountSection;



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/AccountSection/index.js